import { IState } from '../../store';
import { isAbUseExperimentsActive } from '../abUseExperiments';

export const NEWBUILDINGS_TRANSPORT_INDEX_REMOVING = 'newbuilding_transport_index_negative_web';

/**
 * TODO: Удалить файл после раскатки эксперимента
 */
export const selectTransportAccessibilityActive = (state: IState) => {
  const { abUseExperiments } = state;

  if (isAbUseExperimentsActive(abUseExperiments, NEWBUILDINGS_TRANSPORT_INDEX_REMOVING, 'disabled')) {
    return true;
  }

  if (isAbUseExperimentsActive(abUseExperiments, NEWBUILDINGS_TRANSPORT_INDEX_REMOVING, 'enabled')) {
    // Аналитика хочет, чтобы первое время мы игнорировали эту группу. В норме здесь должно быть false.
    return state.rs.transportIndexEnabledGroupIgnored;
  }

  return true;
};
